import {createSlice} from '@reduxjs/toolkit';

export interface CompanyState {
    assignedModules: any[];
    allModules: any[];
    preferences: any;
}

const initialState: CompanyState = {
    assignedModules: [],
    preferences: {
        tcs: false,
        tds: false,
        transportationCharge: false,
        labourCharge: false,
        quantity: false,
        invoiceNumber: '1',
        purchaseNumber: '1',
        creditNoteNumber: '1',
        debitNoteNumber: '1',
        receiptVoucherNumber: '1',
        paymentVoucherNumber: '1',
        dueDays: 1,
    },
    allModules: []
};

const companySlice = createSlice({
    name: 'company',
    initialState,
    reducers: {
        loadModules(state, action) {
            state.assignedModules = action.payload.modules;
        },
        loadPreferences(state, action) {
            state.preferences = action.payload;
        },
        loadAllModules(state, action) {
            state.allModules = action.payload;
        }
    },
});

export const {
    loadModules, loadPreferences, loadAllModules
} = companySlice.actions;
export default companySlice.reducer;
